import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class statusManagerService {
  constructor(private http: HttpClient) {}

  urlApiManagement = environment.urlApiManagement;

  getStatus(requestId: any) {
    const url = `${this.urlApiManagement}/api/v1/status/status/${requestId}`;
    return this.http.get(url, {});
  }

  getTeams() {
    const url = `${this.urlApiManagement}/api/v1/status/teams`;
    return this.http.get(url, {});
  }

  saveStatusFlow(status: StatusStructure[]) {
    const url = `${this.urlApiManagement}/api/v1/status/create-list-status`;
    const body = status;
    return this.http.post(url, body);
  }

  updateStatus(updateParams: StatusStructure[]) {
    const url = `${this.urlApiManagement}/api/v1/status/request-status-updates`;
    const body = updateParams;
    return this.http.post(url, body);
  }
}

interface StatusStructure {
  statusId: number;
  seq: number;
  statusName: string | null;
  requestId: number;
  teamRespId: number;
  teamRespName: string | null;
  previousStatusId: null;
  nextStatusId: null;
  previousStatusName: string | null;
  nextStatusName: string | null;
  actionName: string | null;
  comments: string | null;
  creationDate: string;
  createdById: number;
  updateDate: string | null;
  updatedBy: number | null;
  multipleSelecFlag: boolean;
  requestorAreaFlag: boolean;
  processEndFlag: boolean;
  justificationFlag: boolean;
  statusFlag: string | null;
}
